import React from 'react';
import '../Css_files/CompanyHeader.css';

const CompanyHeader = () => {
  return (
    <div className="company-header">
      <div className="header-title-container">
        <h1 className="header-title">
          Profenaa
          <span className="header-title-accent">Gallery</span>
        </h1>
        <div className="header-divider"></div>
      </div>
      
      <p className="header-description">
        Celebrating our journey of innovation, excellence, and memorable moments that define our commitment to technological advancement and client success.
      </p>
      
      {/* <div className="header-stats">
        <div className="stat-item">
          <div className="stat-dot blue"></div>
          <span>200+ Team Members</span>
        </div>
        <div className="stat-item">
          <div className="stat-dot green"></div>
          <span>50+ Global Partners</span>
        </div>
        <div className="stat-item">
          <div className="stat-dot purple"></div>
          <span>99.8% Client Satisfaction</span>
        </div>
      </div> */}
    </div>
  );
};

export default CompanyHeader;